<template>
    <div>
        <section class="section">
            <div class="container">
                <div class="columns">
                    <div class="column is-3"></div>
                    <div class="column is-6">
                        <div id="meme-card" class="card">
                            <div class="card-image">
                                <div v-if="image == null && error == false">
                                    <Spinner size="big" />
                                    <br />
                                    <p style="text-align: center;">Generating meme...</p>
                                </div>

                                <div v-if="image != null">
                                    <figure id="meme" class="image is-3by5">
                                        <img :src="image" alt="Generated meme">
                                    </figure>

                                    <div class="columns is-centered">
                                        <div class="column has-text-centered is-half">
                                            <button @click="generateMeme" class="button is-primary">Generate a new meme</button>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="image == null && error == true">
                                    <p style="text-align: enter">Error generating meme</p>
                                    <br/>

                                    <div class="columns is-centered">
                                        <div class="column has-text-centered is-half">
                                            <button @click="generateMeme" class="button is-primary">Retry</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-3"></div>
                </div>
            </div>
        </section>

        <footer class="footer">
            <div class="content has-text-centered">
                <p>
                    Created with ❤️ in Maastricht 🇳🇱 by <a href="https://github.com/WalterSimoncini">Walter Simoncini</a>
                </p>
                <p>
                    Do you want to build your own? Check out <a href="https://blog.ashita.nl/p/how-to-build-your-own-meme-generator/">this blog post</a>
                </p>
            </div>
        </footer>
    </div>
</template>

<script>

const axios = require("axios");
import Spinner from 'vue-simple-spinner'


export default {
  name: "Generator",
  components: {
    Spinner
  },
  data: function () {
    return {
        image: null,
        error: false,
        api: axios.create({
            baseURL: process.env.VUE_APP_API_ROOT,
        })
    }
  },
  mounted: function () {
    this.generateMeme();
  },
  methods: {
    generateMeme: function () {
        let view = this;

        this.error = false;
        this.image = null;

        this.api.get('meme/drake/50')
            .then(function (response) {
                view.image = `data:image/png;base64, ${response.data.image}`;
            })
            .catch(function (error) {
                console.log(error);

                view.$buefy.toast.open({
                    message: 'Error generating the meme. Please retry',
                    type: 'is-danger'
                });

                view.error = true;
            });
    }
  }
};

</script>

<style>

#meme-card {
    padding: 16px;
    box-shadow: 0 0.5em 1.5em -0.125em rgba(10, 10, 10, 0.25), 0 0px 0 1px rgba(10, 10, 10, 0.02);
}

#meme {
    margin-bottom: 16px;
}

.footer {
    padding-bottom: 3rem;
}

</style>